module.exports = __webpack_public_path__ + "static/media/termo_de_anuencia_do_representante_legaldomenor.4d5e9c1d.pdf";